import PageLayout from "../components/site/PageLayout";
import { Reveal } from "../components/site/Reveal";
import { SectionHeading } from "../components/site/SectionHeading";
import { StatCounter } from "../components/site/StatCounter";
import { useContent } from "../lib/content";
import { Quote } from "lucide-react";

const Impact = () => {
  const { content } = useContent();
  return (
    <PageLayout title="Impact">
      <section className="relative pt-16 pb-10 overflow-hidden">
        <div className="ambient" aria-hidden />
        <div className="ambient-grid" aria-hidden />
        <div className="container-tt">
          <SectionHeading eyebrow="Impact" title="Measured in lives, not just numbers." description="TechTies is growing steadily across Orange County. Here's a look at the community we're building and the work ahead." />
        </div>
      </section>

      <section className="py-14">
        <div className="container-tt grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {content.stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.05}>
              <div className="card-surface card-lift p-6 h-full">
                <span className="tie-top" aria-hidden />
                <div className="mt-4 font-display text-4xl md:text-[2.75rem] leading-none text-stone">
                  <StatCounter value={s.value} prefix={s.prefix} suffix={s.suffix} />
                </div>
                <div className="mt-3 text-sm text-muted-foreground">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-20">
        <div className="container-tt">
          <SectionHeading eyebrow="Timeline" title="Our journey so far." />
          <ol className="mt-14 relative pl-10 space-y-14" data-testid="timeline">
            <span className="absolute left-0 top-2 bottom-2 w-px bg-gradient-to-b from-sky/70 via-border to-transparent" aria-hidden />
            {content.timeline.map((e, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <li className="relative">
                  <span className="absolute -left-[45.5px] top-1 h-3 w-3 rounded-full bg-sky ring-4 ring-white shadow-[0_0_0_5px_rgba(14,165,233,.12)]" />
                  <div className="eyebrow">{e.date}</div>
                  <div className="font-display text-2xl md:text-3xl mt-2.5 text-stone">{e.title}</div>
                  <p className="mt-3 text-lg text-muted-foreground leading-relaxed max-w-2xl">{e.body}</p>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <section className="py-20 border-t border-border/60 bg-gradient-to-b from-white to-accent/30">
        <div className="container-tt">
          <SectionHeading eyebrow="In their words" title="What our community says." />
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {content.testimonials.map((t, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <figure className="card-surface card-lift p-8 h-full flex flex-col">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-accent/70 text-skyDark"><Quote size={18} /></span>
                  <blockquote className="mt-5 font-display italic text-[19px] leading-relaxed text-stone/90 flex-1">"{t.quote}"</blockquote>
                  <figcaption className="mt-6 pt-5 border-t border-border/70 flex items-center gap-3">
                    {t.image ? (
                      <img src={t.image} alt={t.author} className="h-11 w-11 rounded-full object-cover" />
                    ) : (
                      <span aria-hidden className="h-11 w-11 rounded-full bg-accent text-skyDark grid place-items-center font-display text-lg">{(t.author || "?").charAt(0)}</span>
                    )}
                    <span className="text-sm">
                      <div className="font-medium">{t.author}</div>
                      <div className="text-muted-foreground">{t.role}</div>
                    </span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Impact;
